<div
  class="text-red-500 !text-[10px] mt-1 min-h-[12px]"
  [class.invisible]="!errorMessage">
  {{ errorMessage }}
</div>
